export const USER_ACTIONS_CP = {
    VIEW_FILTERS_UTUT_BABY_LOCALE: 'view-filters-utut-baby-locale',
    DRAFT_PUBLISH_UTUT_TO_LIVE: 'draft-publish-utut-to-live',
    DRAFT_SEND_UTUT_TO_LOC: 'draft-send-utut-to-localization',
    DRAFT_REFRESH_UTUT_FOR_TB: 'draft-refresh-utut-for-tutorial-builder',
    DRAFT_CREATE_NEW_PL: 'draft-create-new-playlist',
    DRAFT_CREATE_NEW_CL: 'draft-create-new-collection',
    LIVE_ARCHIVE_UTUT: 'live-archive-utut',
    LIVE_UNARCHIVE_UTUT: 'live-unarchive-utut',
    LIVE_CREATE_NEW_PL: 'live-create-new-playlist',
    LIVE_CREATE_NEW_CL: 'live-create-new-collection',
    EDIT_PL: 'edit-playlist',
    EDIT_CL: 'edit-collection',
    DELETE_PL: 'delete-playlist',
    DELETE_CL: 'delete-collection',
};

export default USER_ACTIONS_CP;
